// extracted by mini-css-extract-plugin
module.exports = {"root":"_35622999","isVariantPrimary":"_8bfa2771","isVariantSecondary":"_537a0bd1","title":"_2bb611c3","minPriceInput":"_a390816e","maxPriceInput":"_0b61c0a4"};